module.exports = __webpack_public_path__ + "static/media/icon-expand-person.a05ecb4f.svg";